import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Alert } from 'shared/mui/Alert/Alert';
import { Button } from 'shared/mui/Buttons';
import { Typography } from 'shared/mui/Typography';

type Props = {
  onClick: VoidFunction;
};

export const OrderAdjustmentsFormAlertPreview: React.FC<Props> = ({ onClick }) => {
  const translate = useTypedTranslate();

  return (
    <Alert
      action={
        <Button
          color="primary"
          label={translate('app.adjustments.searchById')}
          onClick={onClick}
          sx={{ width: '110px', padding: '6px' }}
          variant="contained"
        />
      }
      severity="info"
      sx={{ mt: '12px' }}
    >
      <Typography fontWeight={500} sx={{ mb: '4px' }}>
        {translate('app.adjustments.preview')}
      </Typography>
      <Typography variant="body2">{translate('app.adjustments.previewDescription')}</Typography>
    </Alert>
  );
};
